import { Focused } from "react-credit-cards";
import { Form, message, Spin } from "antd";
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
  useMemo,
} from "react";
import Footer from "./components/Footer";
import { CardForm } from "./components/CardForm";
import AddressForm from "./components/AddressForm";
import { ResultScreen } from "./components/ResultScreen";
import api from "../../../../services/api";
import { removeSpecialCharacters } from "../../../../utils";
import { IClient, useClients } from "../../../../contexts/ClientsContext";
import { Plan as IPlan, UserPlan } from "../../../../constants/plans";
import { PendingScreen } from "./components/ResultScreen/components/PendingScreen";
import { useAuth } from "../../../../contexts/AuthContext";
import { ICreatePaymentXPPro } from "..";

export enum ETypePurchase {
  MEI = "MEI",
  UNIQUE = "UNIQUE",
  VELOTAX_MAIN_BASIC = "VELOTAX_MAIN_BASIC",
  VELOTAX_MAIN_BASIC_MONTH = "VELOTAX_MAIN_BASIC_MONTH",
  VELOTAX_MAIN_PRO = "VELOTAX_MAIN_PRO",
  VELOTAX_MAIN_PRO_MONTH = "VELOTAX_MAIN_PRO_MONTH",
  VELOTAX_MAIN_CONCIERGE = "VELOTAX_MAIN_CONCIERGE",
  VELOTAX_MAIN_CONCIERGE_MONTH = "VELOTAX_MAIN_CONCIERGE_MONTH",
}

interface ICreditCardStepProps {
  status: string;
  initialized: boolean;
  handleBack?: () => void;
  typePurchase: ETypePurchase;
  handleSuccess?: (res: any) => void;
  setInitialized: Dispatch<SetStateAction<boolean>>;
  handleClosableModal: Dispatch<SetStateAction<boolean>>;
  plan?: IPlan | UserPlan;
  darfData?: any;
  getCardCurrentStep?: (value: number) => void;
  handleIdBack?: (event: any) => void;
  customInstallments?: number;
  backToRoot?: () => void;
  clientSelected?: IClient;
  createPlanXPPro: (body: ICreatePaymentXPPro) => void 
}

export const CreditCardStep: React.FC<ICreditCardStepProps> = ({
  plan,
  handleBack,
  handleClosableModal,
  typePurchase,
  darfData,
  handleSuccess,
  handleIdBack,
  customInstallments,
  backToRoot,
  clientSelected,
  createPlanXPPro
}) => {
  const { selectedClient } = useClients();
  const { user } = useAuth();
  const [cardForm] = Form.useForm();
  const [addressForm] = Form.useForm();

  const [cvc, setCvc] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [status] = useState("");
  const [number, setNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [focused, setFocused] = useState<Focused>();
  const [holderDocument, setHolderDocument] = useState("");
  const [installments, setInstallments] = useState(1);

  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isValidCardForm, setIsValidCardForm] = useState(false);
  const [isValidAddressForm, setIsValidAddressForm] = useState(false);

  const isPlan = useMemo(() => {
    return [
      "VELOTAX_MAIN_BASIC",
      "VELOTAX_MAIN_BASIC_MONTH",
      "VELOTAX_MAIN_PRO",
      "VELOTAX_MAIN_PRO_MONTH",
      "VELOTAX_MAIN_CONCIERGE",
      "VELOTAX_MAIN_CONCIERGE_MONTH",
    ].includes(plan?.type || "");
  }, [plan]);

  const value = useMemo(() => {
    if (isPlan) return plan && ((plan as any)?.fullPrice || (plan?.price * 12));
    return darfData?.impostoTotalFinal;
  }, [darfData?.impostoTotalFinal, plan, isPlan]);

  useEffect(() => {
    if (currentStep < 0) {
      if (handleBack) handleBack();
    }
  }, [currentStep, handleBack]);

  const handleCreatePlanXPPro = () => {
    const addressInfo = addressForm.getFieldsValue();
    const monthExp = expiry?.split("/")?.[0];
    const monthYear = expiry?.split("/")?.[1];
    const body = {
      cardInfo: {
        line_1: `${addressInfo?.neighborhood} - ${addressInfo?.street} - ${addressInfo?.number}`,
        zip_code: addressInfo?.cep?.replace("-", ""),
        city: addressInfo?.city,
        state: addressInfo?.state.toUpperCase(),
        holder_name: removeSpecialCharacters(name),
        number,
        exp_month: monthExp,
        exp_year: monthYear,
        holderDocument,
        cvv: cvc,
      },
      clientInfo: {
        name: user.user.name,
        email: user.user.email,
        document: user.user.username,
        phone,
        isAssessor: true
      },
      paymentForm: "credit_card",
      from: "VELOPRIME",
      installments: cardForm.getFieldValue("installments") ?? 12,
    }

    createPlanXPPro(body)


    // setLoading(true);
    // handleClosableModal(false);

    // api
    //   .post(url, {
    //     ...darfData,
    //     type: plan?.type,
    //     paymentForm: "credit_card",
    //     installments: 12,
    //     clientUserId: selectedClient?._id,
    //     cardInfo: {
    //       line_1: `${addressInfo?.neighborhood} - ${addressInfo?.street} - ${addressInfo?.number}`,
    //       zip_code: addressInfo?.cep?.replace("-", ""),
    //       city: addressInfo?.city,
    //       state: addressInfo?.state.toUpperCase(),
    //       holder_name: removeSpecialCharacters(name),
    //       number,
    //       exp_month: monthExp,
    //       exp_year: monthYear,
    //       holderDocument,
    //       cvv: cvc,
    //     },
    //     clientInfo: {
    //       name: user.user.name,
    //       email: user.user.email,
    //       document: user.user.username,
    //       phone,
    //     },
    //   })
    //   .then((res: any) => {
    //     if (res.data.paymentId || res.data.paymentRecurringId)
    //       handleSuccess && handleSuccess(res.data);
    //     setCurrentStep(3);
    //   })
    //   .catch((err) => {
    //     message.error(err.response?.data?.message);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //     handleClosableModal(true);
    //   });
  };
  const createUniquePayment = () => {
    const addressInfo = addressForm.getFieldsValue();

    let url = "/darf";
    const monthExp = expiry?.split("/")?.[0];
    const monthYear = expiry?.split("/")?.[1];

    setLoading(true);
    handleClosableModal(false);

    api
      .post(url, {
        ...darfData,
        paymentForm: "credit_card",
        clientUserId: selectedClient?._id,
        paymentInfo: {
          installments: installments,
          cardInfo: {
            line_1: `${addressInfo?.neighborhood} - ${addressInfo?.street} - ${addressInfo?.number}`,
            zip_code: addressInfo?.cep?.replace("-", ""),
            city: addressInfo?.city,
            state: addressInfo?.state.toUpperCase(),
            holder_name: removeSpecialCharacters(name),
            number,
            exp_month: monthExp,
            exp_year: monthYear,
            cvv: cvc,
          },
          clientInfo: {
            name: user.user.name,
            email: user.user.email,
            document: user.user.username,
            phone,
          },
        },
      })
      .then((res: any) => {
        setCurrentStep(2);
      })
      .catch((err) => {
        message.error(err.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
        handleClosableModal(true);
      });
  };

  const handleNextStep = () => {
    if (currentStep === 0) {
      setCurrentStep(1);
    } else if (currentStep === 1) {
      if (typePurchase === "UNIQUE") {
        createUniquePayment();
      } else if (
        [
          "VELOTAX_MAIN_BASIC",
          "VELOTAX_MAIN_BASIC_MONTH",
          "VELOTAX_MAIN_PRO",
          "VELOTAX_MAIN_PRO_MONTH",
          "VELOTAX_MAIN_CONCIERGE",
          "VELOTAX_MAIN_CONCIERGE_MONTH",
        ].includes(typePurchase)
        ) {
        handleCreatePlanXPPro();
      }
    }
  };

  const getConditionToDisable = () => {
    switch (currentStep) {
      case 0:
        return !isValidCardForm;
      case 1:
        return !isValidAddressForm;
      default:
        return false;
    }
  };

  const changeInstallments = (value: any) => {
    setInstallments(value);
  };

  return (
    <div>
      <Spin spinning={loading}>
        {currentStep === 0 && (
          <>
            <CardForm
              form={cardForm}
              number={number}
              setCvc={setCvc}
              setName={setName}
              focused={focused}
              setPhone={setPhone}
              setNumber={setNumber}
              setExpiry={setExpiry}
              setFocused={setFocused}
              setHolderDocument={setHolderDocument}
              setIsValidCardForm={setIsValidCardForm}
              uniqueValue={value}
              signature={(plan as UserPlan)?.interval === "Mensal"}
              fixedInstallments={isPlan ? 12 : undefined}
              handleBack={changeInstallments}
              installmentSelected={installments}
              customInstallments={customInstallments}
              plan={plan}
            />
          </>
        )}

        {currentStep === 1 && (
          <AddressForm
            form={addressForm}
            setLoading={setLoading}
            setIsValidAddressForm={setIsValidAddressForm}
          />
        )}

        {currentStep === 2 && (
          <ResultScreen
            plan={plan as IPlan}
            status={status}
            setCurrentStep={setCurrentStep}
          />
        )}

        {currentStep === 3 && <PendingScreen />}
        <Footer
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          hideTerms
          handleProceed={handleNextStep}
          getConditionToDisable={getConditionToDisable}
          typePurchase={typePurchase}
          backtoRoot={backToRoot}
        />
      </Spin>
    </div>
  );
};

export default CreditCardStep;